import { Address } from "../../../../src/elements";
import * as React from 'react';
export default {
  Address,
  React
};